var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-insta",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_13",
    "data-name": "Rettangolo 13",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1161953_instagram_icon",
    "data-name": "1161953_instagram_icon",
    transform: "translate(-0.4 -1.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9",
    "data-name": "Tracciato 9",
    d: "M20.045,16.7a4.645,4.645,0,1,0,4.645,4.645A4.654,4.654,0,0,0,20.045,16.7Zm0,7.621a2.976,2.976,0,1,1,2.976-2.976A2.989,2.989,0,0,1,20.045,24.321Z",
    transform: "translate(-7.645 -7.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1",
    "data-name": "Ellisse 1",
    cx: 1.052,
    cy: 1.052,
    r: 1.052,
    transform: "translate(16.174 7.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10",
    "data-name": "Tracciato 10",
    d: "M19.948,6.288A5.168,5.168,0,0,0,16.138,4.8H8.662A4.971,4.971,0,0,0,3.4,10.062V17.5a5.222,5.222,0,0,0,1.524,3.883A5.3,5.3,0,0,0,8.7,22.8h7.4a5.359,5.359,0,0,0,3.81-1.415A5.2,5.2,0,0,0,21.4,17.538V10.062A5.2,5.2,0,0,0,19.948,6.288ZM19.8,17.538a3.546,3.546,0,0,1-1.052,2.649,3.751,3.751,0,0,1-2.649.944H8.7a3.751,3.751,0,0,1-2.649-.944,3.648,3.648,0,0,1-.98-2.685v-7.44a3.618,3.618,0,0,1,.98-2.649A3.69,3.69,0,0,1,8.7,6.469h7.476a3.618,3.618,0,0,1,2.649.98,3.745,3.745,0,0,1,.98,2.613v7.476Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsta);
export default __webpack_public_path__ + "static/media/icon-insta.0ebc429f8b6fa92360514cd55a24f821.svg";
export { ForwardRef as ReactComponent };